"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplate = void 0;
const getTemplate = async (supabase, template_id, language_code) => {
    const { data: template, error: template_error } = await supabase
        .from("email_templates")
        .select(`
        *,
        versions:email_template_versions(
          *,
          language:languages!inner(*)
        )
      `)
        .eq("id", template_id)
        .eq("versions.language.code", language_code)
        .eq("active", true)
        .single();
    if (template_error || !template) {
        return null;
    }
    // 🧠 Filter to only active version(s)
    const activeVersion = template.versions.find((v) => v.active === true);
    if (!activeVersion)
        return null;
    const result = {
        id: template.id,
        name: template.name,
        description: template.description,
        category: template.category,
        snippet: activeVersion.snippet,
        sub_category: template.sub_category,
        subject: activeVersion.subject,
        html: activeVersion.html,
        default_recipient: template.default_recipient,
        active: template.active,
        default_to: template.default_to,
        default_cc: template.default_cc,
        default_bcc: template.default_bcc,
        hide_do_not_reply_banner: template.hide_do_not_reply_banner || false,
    };
    return result;
};
exports.getTemplate = getTemplate;
